import cn from "classnames";
import { useContext } from "react";
import { Button, Icon } from "capitalrx-components-2.0/lib/general";
import { SubmitButton } from "capitalrx-components-2.0/lib/forms";
import { ThemeSelectorContext } from "@/context/index";
import { WhiteLabelButtonProps } from "./WhiteLabelButtonProps";

import styles from "./WhiteLabelButton.module.scss";

export const WhiteLabelButton = (props: WhiteLabelButtonProps) => {
  const { text, classNames, icon, onClick } = props;
  const { client } = useContext(ThemeSelectorContext);

  const buttonClassname = cn(classNames, { [styles.WhiteLabeled]: !!client });

  return (
    <Button onClick={onClick} className={buttonClassname}>
      {icon && (
        <span className={styles.WhiteLabeledIcon}>
          <Icon color="darkgrey" name={icon} />
        </span>
      )}
      {text}
    </Button>
  );
};

export const WhiteLabelSubmit = (props: WhiteLabelButtonProps) => {
  const { text, classNames, icon } = props;
  const { client } = useContext(ThemeSelectorContext);

  const buttonClassname = cn(classNames, { [styles.WhiteLabeled]: !!client });

  return (
    <SubmitButton className={buttonClassname}>
      {text}
      {icon && <Icon color="white" size="regular" name={icon} />}
    </SubmitButton>
  );
};
